import { render, staticRenderFns } from "./ReliableAndReady.vue?vue&type=template&id=22e21ee7&"
import script from "./ReliableAndReady.vue?vue&type=script&lang=js&"
export * from "./ReliableAndReady.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports